import { Icampaignschedule } from "../campaing/campaign.model";

export interface IStatusSchedule {
  scheduleId: number,
  country: string,
  divisionId: number,
  dealerId: number,
  dealerName: string,
  dealerStreet: string,
  dealerCity: string,
  dealerState: string,
  advisorId: number,
  advisorName: string,
  scheduleDate: string,
  scheduleHour: number,
  checkInHour: number,
  vin: string,
  customerId: number,
  deliveryScheduleDate: string,
  deliveryScheduleHour: number,
  hourSchedule: string,
  dateSchedule: string,
  countryId: string,
  campaignsIds: number[],
  revisioncampaigns: Icampaignschedule[],
  remark: string,
}
